import React, { useEffect, useState } from "react";
import { Button, Checkbox, Modal, ModalDialog, Option, Radio, RadioGroup, Select } from "@mui/joy";
import { postFetch } from "../../../../../../fetch/fetch";


const WeekPayModal: React.FC<any> = (props) => {

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        console.log(props.selectedWeekPayDays);

    }, [props.open]);

    const submit = async () => {

        if(!props.user){
            return;
        }

        if(!props.selectedWeekPayDays){
            return;
        }

        console.log(props.user);

        try{

            setLoading(true);

            const result : any = await postFetch("/dashboard/salary/setweekpaydays", {
                userId : props.user.id,
                days : props.selectedWeekPayDays,
            });

            console.log(result);

            if(result.message === "success"){
                props.notify("success", "저장 성공");
                props.onClose();
            }

            if(result.message === "NO_TODOIST_API_KEY"){
                props.notify("error", "본사 직원만 설정할 수 있습니다.");
            }

            setLoading(false);

        }catch(e){
            console.log(e);
            setLoading(false);
        }

    }



    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
        >
            <ModalDialog>
                <div style={{
                    width: "300px"
                }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "15px" }}>
                        의무 근무 요일 선택
                    </div>
                    <div>
                        {
                            ["일", "월", "화", "수", "목", "금", "토"].map((day, index) => {
                                return (
                                    <div style={{
                                        marginBottom: "2px"
                                    }}>
                                        <Checkbox
                                            checked={props.selectedWeekPayDays[index]}
                                            key={index}
                                            label={day + "요일"}
                                            onChange={(e: any) => {

                                                const checked = e.target.checked;
                                                let newSelectedDays = [...props.selectedWeekPayDays];
                                                console.log(checked);
                                                newSelectedDays[index] = checked ? true : false;
                                                props.setSelectedWeekPayDays(newSelectedDays);

                                            }}
                                        />
                                    </div>

                                )
                            })
                        }
                    </div>
                    <div style={{
                        marginTop: "15px"
                    }}>
                        <Button
                            fullWidth
                            variant="solid"
                            color="primary"
                            onClick={submit}
                            loading={loading}
                        >
                            저장하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    )
}

export default WeekPayModal;